import React from 'react';
import { ArrowUpIcon, MailIcon, MessageCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { EMAIL_ADDRESS, EMAIL_URL, LOGO_URL } from '../lib/constants';
export function Footer() {
  return <footer className="w-full bg-ink text-white" data-id="element-52" data-mp="32p5mig4yiwos">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8 sm:py-14" data-id="element-53" data-mp="36pftnw4hjt58">
        <div className="flex flex-col justify-between gap-10 border-b border-white/15 pb-10 md:flex-row md:items-end" data-id="element-54" data-mp="36ppjnjpj60ax">
          <div data-id="element-55" data-mp="3ud7ddkscv8gj">
            <img src={LOGO_URL} alt="Byronweb — Creación y diseño digital" className="h-12 w-auto bg-white p-1.5" data-id="element-56" data-mp="38h3r5ed5aiu" />
            <p className="mt-5 max-w-sm font-display text-3xl font-extrabold leading-none text-lime" data-id="element-57" data-mp="3lf58uv9exxoi">
              Tu web también puede ser imposible de ignorar.
            </p>
          </div>
          <div className="flex flex-col items-start gap-4 md:items-end" data-id="element-58" data-mp="29ynjtg85axbw">
            <CtaButton variant="light" size="md" icon={<MessageCircleIcon className="h-4 w-4" data-id="element-60" data-mp="2ezb9nykn184j" />} data-id="element-59" data-mp="2ey9yzv7jannc">
              Hablemos de tu idea
            </CtaButton>
            <a href={EMAIL_URL} className="inline-flex items-center gap-2 text-sm font-bold text-slate-300 transition-colors hover:text-lime focus:outline-none focus-visible:ring-4 focus-visible:ring-lime" data-id="element-61" data-mp="3la2a6wqof7wa">
              <MailIcon className="h-4 w-4" data-id="element-62" data-mp="3q8wqns168kd8" />
              {EMAIL_ADDRESS}
            </a>
          </div>
        </div>

        <div className="flex flex-col justify-between gap-4 pt-7 text-sm font-semibold text-slate-400 sm:flex-row sm:items-center" data-id="element-63" data-mp="828nw8tlg9aq">
          <p data-id="element-64" data-mp="33e4b4nsygpk">© Byronweb · Diseño web con intención</p>
          <a href="#top" className="inline-flex items-center gap-2 transition-colors hover:text-lime" data-id="element-65" data-mp="htd1b43mfm3g">
            Volver arriba <ArrowUpIcon className="h-4 w-4" data-id="element-66" data-mp="cus0b2gjoydy" />
          </a>
        </div>
      </div>
    </footer>;
}